module.exports = __webpack_public_path__ + "static/assets/a8ee736482de0a1d1456c776f55c62da.svg";